(function () {
  'use strict';

  const globalKey = '__ppCollectionManager';

  if (window[globalKey]) {
    window[globalKey].initAll(document);
    return;
  }

  const instances = new Map();
  const desktop = window.matchMedia('(min-width: 990px)');

  function formatPrices(root) {
    root.querySelectorAll('[data-pp-price]').forEach((el) => {
      const raw = el.dataset.priceCents;

      if (raw == null || raw.trim() === '') return;

      const cents = Number(raw);
      if (!Number.isFinite(cents)) return;

      const currency = el.dataset.currency || 'SEK';

      try {
        const hasFraction = Math.abs(cents % 100) > 0;

        el.textContent = new Intl.NumberFormat('sv-SE', {
          style: 'currency',
          currency,
          minimumFractionDigits: hasFraction ? 2 : 0,
          maximumFractionDigits: 2,
        })
          .format(cents / 100)
          .replace(currency === 'SEK' ? /\s*SEK$/i : /$^/, ' kr');
      } catch (_) {
        // Behåll Shopifys pris om formateringen misslyckas.
      }
    });
  }

  function init(root) {
    if (instances.has(root)) return;

    const controller = new AbortController();
    const options = { signal: controller.signal };
    const form = root.querySelector('[data-pp-filter-form]');
    const toggle = root.querySelector('[data-pp-open-filters]');

    function close(restoreFocus) {
      root.classList.remove('is-filter-open');
      toggle?.setAttribute('aria-expanded', 'false');

      if (restoreFocus) toggle?.focus();
    }

    function submit() {
      form?.requestSubmit();
    }

    toggle?.addEventListener('click', () => {
      const open = root.classList.toggle('is-filter-open');
      toggle.setAttribute('aria-expanded', String(open));
    }, options);

    root.querySelectorAll('[data-pp-close-filters]').forEach((el) => {
      el.addEventListener('click', () => close(true), options);
    });

    root.querySelectorAll('[data-pp-filter-input]').forEach((el) => {
      el.addEventListener('change', () => {
        if (desktop.matches) submit();
      }, options);
    });

    root.querySelectorAll('[data-pp-auto-submit]').forEach((el) => {
      el.addEventListener('change', submit, options);
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const detail = event.target.closest(
        '[data-pp-filter-details][open]'
      );

      if (detail) {
        detail.open = false;
        detail.querySelector('summary')?.focus();
      } else if (root.classList.contains('is-filter-open')) {
        close(true);
      }
    }, options);

    document.addEventListener('click', (event) => {
      if (!desktop.matches) return;

      root.querySelectorAll('[data-pp-filter-details][open]')
        .forEach((el) => {
          if (!el.contains(event.target)) el.open = false;
        });
    }, options);

    desktop.addEventListener('change', () => {
      if (desktop.matches) close(false);
    }, options);

    form?.addEventListener('formdata', (event) => {
      for (const [key, value] of Array.from(event.formData.entries())) {
        if (value === '' && /^filter\.v\.price\./.test(key)) {
          event.formData.delete(key);
        }
      }
    }, options);

    root.classList.add('is-enhanced');
    formatPrices(root);
    instances.set(root, controller);
  }

  function initAll(scope) {
    for (const [root, controller] of instances) {
      if (!root.isConnected) {
        controller.abort();
        instances.delete(root);
      }
    }

    if (scope.matches?.('[data-pp-collection]')) init(scope);

    scope.querySelectorAll?.('[data-pp-collection]').forEach(init);
  }

  window[globalKey] = { initAll };

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    for (const [root, controller] of instances) {
      if (root === event.target || event.target.contains(root)) {
        controller.abort();
        instances.delete(root);
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }
})();